import { preview } from '@/components/form/preview'

import { Header } from './components/Header'
import { useBulkValues } from './hooks/useBulkValues'
import { useTexts } from './hooks/useTexts'

type SingleViewProps = {
  depots: uui.domain.client.rm.Depot[]
}

function isNull(value: number) {
  return value <= 0
}

export function BulkPreview(props: SingleViewProps) {
  const { depots } = props
  const { labels } = useTexts()
  const {
    address,
    setupCost,
    setupTimeSec,
    addressMultipleValues,
    setupCostMultipleValues,
    setupTimeSecMultipleValues,
  } = useBulkValues(depots)

  return (
    <preview.Root applyPendingFitMapOnMount header={<Header depots={depots} />}>
      <preview.Field label={labels.address}>
        {addressMultipleValues ? <preview.MultipleValues /> : address}
      </preview.Field>

      <preview.Divider />

      <preview.Field label={labels.setupCost}>
        {setupCostMultipleValues ? (
          <preview.MultipleValues />
        ) : (
          <preview.CurrencyValue isNull={isNull}>{setupCost}</preview.CurrencyValue>
        )}
      </preview.Field>

      <preview.Field label={labels.setupCost}>
        {setupTimeSecMultipleValues ? (
          <preview.MultipleValues />
        ) : (
          <preview.DurationValue isNull={isNull}>{setupTimeSec}</preview.DurationValue>
        )}
      </preview.Field>
    </preview.Root>
  )
}
